import interpolate from 'color-interpolate';

// Red -> Green
// Todo: Genericize this, enable different color lerps https://www.notion.so/gamelynx/TL-Genericize-Color-functions-1362f8151e9141bda31c6f5fd3552cd9
const colorMap = interpolate(['rgb(255, 127, 127)', 'rgb(191, 255, 127)']);

const compute = ({ value, maxValue }) => {
  return colorMap(value / maxValue);
};

export default compute;
